import React, {useState, useRef} from "react";
import {FileInfo} from "./FileCard";
import {putFiles,deleteFiles} from "@/api/archivos";
import { ProgressBar } from "../ui/ProgressBar";
import {StatusMessage} from "../ui/StatusMessage";
import "@/styles/files/FilesPopUpWindowStyle.css"

type FilePopUpsProps = {
    apiOperation : boolean,
    apiId : string,
    apiMode: boolean,
    apiRoute : string ,
    apiData: FileInfo[] ,
    apiIndex?: number ,
    onFileCard? : (data: any, mode : boolean) => void,
    onDeleteCard? : (index : number , mode : boolean) => void,
    onClose: () => void
}

export const FilePopUp : React.FC<FilePopUpsProps> = ({apiOperation,apiId,apiMode,apiRoute,apiData,apiIndex,onFileCard,onDeleteCard,onClose}) => {

    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 1024Kb -> 1mb
    const MAX_PUBLIC_FILES = 4;
    const MAX_PRIVATE_FILES = 12; 

    const [uploadFiles,setUploadFiles] = useState<File[]>([]);
    const [status, setStatus] = useState<'uploading'|'success'|'fail'>('success');
    const [statusMessage,setStatusMessage] = useState<string>('');
    const [buttonVisible, setButtonVisible] = useState<boolean>(true);
    const [progressBar,setProgressBar] = useState<boolean>(false);
    // const [uploadProgress,setUploadProgress] = useState<number>(0);
    const progressRef = useRef(0);

       //*Verificamos los files del campo llamado anteriormente e interactuamos con el API

        const fileCheckManager = (event: any) => {
            if(event.target.files)
            {
                const newFiles : File[] = [];
                const lengthFiles = !apiMode ? MAX_PUBLIC_FILES : MAX_PRIVATE_FILES;
                Array.from(event.target.files).forEach((file: any) => {

                    if (file.size > MAX_FILE_SIZE) 
                    {
                        console.error(`El archivo ${file.name} excede el tamaño máximo permitido de ${Math.floor(MAX_FILE_SIZE / 1000000)} MB.`);
                        alert(`El archivo ${file.name} excede el tamaño máximo permitido de ${Math.floor(MAX_FILE_SIZE / 1000000)} MB.`);
                        return;
                    }

                    newFiles.push(file);
                })

                if(apiData && apiData.length < lengthFiles) 
                {
                    const availableSlots = lengthFiles - apiData.length;
                    const filesToAdd = newFiles.slice(0, availableSlots);
                    //* Revisamos ahora los archivos que ya hemos seleccionado
                    setUploadFiles(prevFiles => {
                        const availableUploadSlots = lengthFiles - prevFiles.length;
                        const toAdd = filesToAdd.slice(0,availableUploadSlots);
                        return [...prevFiles,...toAdd];
                    });
                }

            }
        }
    
        const fileUploadManager = async () => {
    
            if(uploadFiles){
    
                setButtonVisible(true);
                setProgressBar(true);
                setStatus('uploading');
                setStatusMessage('Subiendo archivos');
    
                const formData = new FormData();
                Array.from(uploadFiles).forEach((file) => {
                    formData.append('files', file);
                });
    
                try
                {
                    await putFiles(apiId,apiMode,apiRoute,formData,(percent) => {
                        progressRef.current = percent;
                    });
                    
                    setStatus('success');
                    setStatusMessage('Archivos cargados exitosamente');
                    onFileCard?.(uploadFiles,apiMode)
                }
                catch(error){
                    console.log(error);
                    setStatus('fail')
                    setStatusMessage('Carga de archivos fallida');
                }
                finally{

                    setButtonVisible(false);
                }
            }
        }
    
        const fileDeleteManager = async () => {
            
            if (apiIndex !== undefined) {

                setButtonVisible(true);
                setStatus('uploading');
                setStatusMessage('Eliminando archivo');

                try {
                
                    await deleteFiles(apiId, apiMode, apiData[apiIndex].name);
                    setStatus('success');
                    setStatusMessage('Archivo eliminado con éxito');
                    onDeleteCard?.(apiIndex, apiMode);

                } catch (error) {

                    setStatus('fail');
                    setStatusMessage('El archivo no se pudo eliminar');
                    console.log(error);

                } finally {

                    setButtonVisible(false);

                }
            }
        }

    return (
        <div  className = "flex flex-col bg-white rounded border border-black p-4 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 max-w-full sm:max-w-lg w-[90%]">
            {apiOperation ? 
                <div>
                    <h3>Selecciona los archivos que quieres subir :</h3>
                    <div className="flex justify-center m-4">
                        <label className="cursor-pointer rounded bg-blue text-white text-center inline-block w-[70%] h-[70%]"
                            htmlFor = "fileUpload">
                            Selecciona los archivos
                        </label>
                    </div>
                     <input
                        id = "fileUpload"
                        className = "hidden"
                        type = "file" 
                        multiple 
                        accept = ".zip,.jpeg,.jpg,.pdf" 
                        onChange={fileCheckManager}
                        />
                    
                    <p className = "mt-4">
                        Se subiran los siguientes archivos : 
                    </p>
                    <div className="mt-2 overflow-y-auto scrollbar-files pr-2"
                        style={{ maxHeight: '300px' }}>
                    {uploadFiles && [...uploadFiles].map((file,index)=>(
                        <section key={file.name} 
                        className = "mt-2 mb-2 border-b border-gray-300 pb-2">
                            <b>Numero de archivo {index + 1}</b>
                            <ul>
                                <li>Nombre : {file.name}</li>
                                <li>Tamaño: {Math.floor(file.size/1000000)} MB</li>
                            </ul>
                        </section>
                    ))}
                    </div>
                    <div id="button container upload" className="flex justify-center">
                        {buttonVisible ? (
                            <button
                                onClick={onClose}
                                className="rounded bg-red p-2 mb-5 text-white font-bold w-[200px] mt-4 mr-2"
                            >
                                Cancelar
                            </button>
                        ) : (
                            <button
                                onClick={onClose}
                                className="rounded bg-red p-2 mb-5 text-white font-bold w-[200px] mt-4 mr-2"
                            >
                                Cerrar
                            </button>
                        )}
                        {uploadFiles.length > 0 && buttonVisible && (
                            <button onClick={()=>{fileUploadManager()}}
                            className="rounded bg-green p-2 mb-5 text-white font-bold w-[200px] mt-4 ml-2"
                            >
                                Confirmar
                            </button>
                        )}
                    </div>
                    <StatusMessage status = {status} statusMessage={statusMessage}/>
                    <ProgressBar barActivate={progressBar} progressNumber={progressRef}/>
                </div>
            : 
                <div>
                    <h3>El siguiente archivo sera eliminado :</h3>
                    <ul>
                        {typeof apiIndex === "number" && apiData[apiIndex] ? (
                            <>
                                <li>Nombre : {apiData[apiIndex].name}</li>
                                <li>Tamaño: {Math.floor(apiData[apiIndex].size/1000000)} MB</li>
                            </>
                        ) : (
                            <li>No se encontró el archivo seleccionado.</li>
                        )}
                    </ul>
                    <div id="button container delete" className="flex justify-center">
                        {buttonVisible ? (
                            <button
                                onClick={onClose}
                                className="rounded bg-red p-2 mb-5 text-white font-bold w-[200px] mt-4 mr-2"
                            >
                                Cancelar
                            </button>
                        ) : (
                            <button
                                onClick={onClose}
                                className="rounded bg-red p-2 mb-5 text-white font-bold w-[200px] mt-4 mr-2"
                            >
                                Cerrar
                            </button>
                        )}
                        {buttonVisible &&
                             <button onClick={fileDeleteManager}
                            className="rounded bg-green p-2 mb-5 text-white font-bold w-[200px] mt-4 ml-2"
                            >
                                Confirmar
                            </button>
                        }
                    </div>
                    <StatusMessage status = {status} statusMessage={statusMessage}/>
                </div>
            }

        </div>
    )
}

